import React from 'react';
import AcquireWebComponent from '../../framework/MaterialUI'
import { Row, Col } from '../../framework/Grid'
import {splitNumber} from '../../../utils/utility'

const styles={
	tableHeaderStyle: {
		border: 'none',
    background: '#F5F5F5',
    fontSize: '12px',
    fontWeight: "bold"
	},
	tableHeaderColumn: {
		height: '35px',
		color: 'black',
		cursor: 'pointer',
		fontWeight: 'bolder',
		paddingLeft: '10px',
		position:'relative',
		whiteSpace:'nowrap',
		textOverflow:'ellipsis'
	},
	tableTd: {
		paddingLeft: '10px',
		height: '30px',
		borderBottom: '1px solid black',
		whiteSpace:'nowrap',
		overflow:'hidden',
		textOverflow:'ellipsis'
	},
}
class CampaignDetail extends AcquireWebComponent {
	render(){
		const {data} = this.props
		return (<div>
		<div className="light-grey-border mt-20 campaign-detail-container" style={{background:"#FFFFFF"}}>
		  <h2 className="pl-20 pt-20">CAMPAIGN GROUP</h2>
			<Row className="light-grey-border-top light-grey-border-bottom no-margin-bottom pt-5 pb-5 no-padding-left ml-20 no-padding-right mr-20">
				<Col xs="3" sm="3" md="3" lg="3" className="no-padding-left"><strong>Campaign Group Name</strong></Col>
				<Col xs="4" sm="4" md="4" lg="4">{data.name}</Col>
				<Col xs="3" sm="3" md="3" lg="3" className="no-padding-left"><strong>Client Campaign ID</strong></Col>
				<Col xs="2" sm="2" md="2" lg="2">{data.clientCampaignId}</Col>
			</Row>
			<Row className="light-grey-border-bottom pt-5 pb-5 no-margin-bottom no-padding-left ml-20 no-padding-right mr-20 ">
				<Col xs="3" sm="3" md="3" lg="3" className="no-padding-left"><strong>Audience Size</strong></Col>
				<Col xs="4" sm="4" md="4" lg="4">{data.audienceSize ? splitNumber(data.audienceSize)() : ''}</Col>
				<Col xs="3" sm="3" md="3" lg="3" className="no-padding-left"><strong>Campaign Group Start Date</strong></Col>
				<Col xs="2" sm="2" md="2" lg="2">{data.startDate}</Col>
			</Row>
			<Row className="light-grey-border-bottom pt-5 pb-5 no-margin-bottom no-padding-left ml-20 no-padding-right mr-20 ">
				<Col xs="3" sm="3" md="3" lg="3" className="no-padding-left"><strong>Campaign Budget</strong></Col>
				<Col xs="4" sm="4" md="4" lg="4">{data.budget ? '$' + splitNumber(data.budget)() : ''}</Col>
				<Col xs="3" sm="3" md="3" lg="3" className="no-padding-left"><strong>Campaign Group End Date</strong></Col>
				<Col xs="2" sm="2" md="2" lg="2">{data.endDate}</Col>
			</Row>			
			<Row className="light-grey-border-bottom pt-5 pb-5 mb-20 no-margin-bottom no-padding-left ml-20 no-padding-right mr-20 ">
				<Col xs="3" sm="3" md="3" lg="3" className="no-padding-left"><strong>Campaign Group ID</strong></Col>
				<Col xs="4" sm="4" md="4" lg="4">{data.campaignId}</Col>
				<Col xs="3" sm="3" md="3" lg="3" className="no-padding-left"><strong>Campaign Group Status</strong></Col>
				<Col xs="2" sm="2" md="2" lg="2">{data.status}</Col>
			</Row>
		</div>
		<div className="light-grey-border mt-20 campaign-detail-pdf-container" style={{background:"#FFFFFF", display:"none"}}>
			<table style={{width:"100%"}}>
				<thead style={styles.tableHeaderStyle}>
					<tr style={{height:"42px"}}>
						<th style={{width:'16%', paddingLeft:"20px", wordBreak: "break-word"}}><strong>Campaign Group Name</strong></th>
						<th style={{width:'10%', paddingLeft:"20px"}}><strong>Audience Size</strong></th>
						<th style={{width:'10%', paddingLeft:"20px"}}><strong>Campaign Budget</strong></th>
						<th style={{width:'12%', paddingLeft:"20px"}}><strong>Campaign Group ID</strong></th>
						<th style={{width:'12%', paddingLeft:"20px"}}><strong>Client Campaign ID</strong></th>
						<th style={{width:'14%', paddingLeft:"20px"}}><strong>Campaign Group Start Date</strong></th>
						<th style={{width:'14%', paddingLeft:"20px"}}><strong>Campaign Group End Date</strong></th>
						<th style={{width:'12%', paddingLeft:"20px"}}><strong>Campaign Group Status</strong></th>
					</tr>
				</thead>
				<tbody>
					<tr style={{height:"42px"}}>
						<td style={{width:'16%', paddingLeft:"20px", wordBreak: "break-word"}}>{data.name}</td>
						<td style={{width:'10%', paddingLeft:"20px"}}>{data.audienceSize ? splitNumber(data.audienceSize)() : ''}</td>
						<td style={{width:'10%', paddingLeft:"20px"}}>{data.budget ? '$' + splitNumber(data.budget)() : ''}</td>
						<td style={{width:'12%', paddingLeft:"20px"}}>{data.id}</td>
						<td style={{width:'12%', paddingLeft:"20px"}}>{data.clientCampaignId}</td>
						<td style={{width:'14%', paddingLeft:"20px"}}>{data.startDate}</td>
						<td style={{width:'14%', paddingLeft:"20px"}}>{data.endDate}</td>
						<td style={{width:'12%', paddingLeft:"20px"}}>{data.status}</td>
					</tr>
				</tbody>
			</table>
		</div>
		</div>
		)
	}
}

export default CampaignDetail


// WEBPACK FOOTER //
// ./src/components/Campaigns/CreateCampaigns/CampaignDetail.jsx